// Custom events have been added to the theme to make adding
// custom functionality easier. The below events have been
// exposed as well as the associated data for each event.
// To enable this functionality update the 'useCustomEvents' variable in
// the theme-globals.liquid file to 'true'.
 
// [AUDIT FIX #8] Todos os console.log removidos — adicione sua implementação abaixo.
 
/* ==========================================================================
   PRÉ-VENDA POR VARIANTE — ADÔ ATELIÊ
   Trabalha em conjunto com snippets/product-block-pre-venda.liquid.
   - Mostra/esconde o aviso da variante selecionada
   - Marca os tamanhos em pré-venda no seletor (selo visual)
   - Troca o texto do botão de compra
   - Grava line item property "Pré-venda" no carrinho/checkout
   ========================================================================== */
(function () {
  "use strict";
 
  var PROPRIEDADE = "Pré-venda";
 
  function lerMapa(escopo) {
    var el = (escopo || document).querySelector("[data-pre-venda-map]");
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }
 
  function itemDaVariante(mapa, variantId) {
    if (!mapa || !variantId) return null;
    var id = parseInt(variantId, 10);
    for (var i = 0; i < mapa.items.length; i++) {
      if (mapa.items[i].id === id) return mapa.items[i];
    }
    return null;
  }
 
  // Selo visual nos botões de tamanho em pré-venda (antes do clique)
  function marcarTamanhos(mapa) {
    if (!mapa) return;
    mapa.items.forEach(function (item) {
      var botoes = document.querySelectorAll(
        '.dynamic-variant-button[data-option-value="' + item.option + '"]'
      );
      botoes.forEach(function (btn) {
        btn.setAttribute("data-pre-venda-option", "true");
        btn.setAttribute("data-pre-venda-selo", mapa.selo || "pré-venda");
      });
    });
  }
 
  // Texto do botão de compra (respeita esgotado/indisponível)
  function atualizarBotoes(mapa, emPreVenda) {
    var botoes = document.querySelectorAll("[data-add-to-cart]");
    botoes.forEach(function (btn) {
      var texto = btn.querySelector("[data-add-to-cart-text]");
      if (!texto) return;
      if (btn.hasAttribute("disabled")) return; // esgotado: o tema manda
      if (emPreVenda) {
        texto.textContent = mapa.labelBotao || "Comprar em pré-venda";
      } else if (btn.dataset.langAvailable) {
        texto.textContent = btn.dataset.langAvailable;
      }
    });
  }
 
  // Line item property no formulário do produto
  function atualizarPropriedade(item) {
    var forms = document.querySelectorAll("[data-product-form]");
    forms.forEach(function (form) {
      var input = form.querySelector('input[name="properties[' + PROPRIEDADE + ']"]');
      if (item) {
        if (!input) {
          input = document.createElement("input");
          input.type = "hidden";
          input.name = "properties[" + PROPRIEDADE + "]";
          form.appendChild(input);
        }
        input.value = item.propriedade;
      } else if (input) {
        input.remove();
      }
    });
  }
 
  // Stock Level Indicator: em pré-venda o estoque é virtual e o item NÃO está
  // pronto para envio — o indicador mentiria ("últimas unidades" / "pronto para
  // envio"). Ocultamos via atributo + CSS !important para sobreviver à
  // inicialização assíncrona do contador no carregamento da página.
  function atualizarContadorEstoque(emPreVenda) {
    document.querySelectorAll("[data-inventory-counter]").forEach(function (el) {
      el.toggleAttribute("data-pre-venda-oculto", emPreVenda);
    });
  }
 
  function atualizar(variantId) {
    var mapa = lerMapa();
    if (!mapa) return;
 
    var item = itemDaVariante(mapa, variantId);
 
    document.querySelectorAll("[data-pre-venda-aviso]").forEach(function (aviso) {
      aviso.hidden = !(item && aviso.dataset.variantId === String(item.id));
    });
 
    atualizarBotoes(mapa, Boolean(item));
    atualizarPropriedade(item);
    atualizarContadorEstoque(Boolean(item));
  }
 
  function varianteAtual() {
    var input = document.querySelector('[data-product-form] [name="id"]');
    return input ? input.value : null;
  }
 
  function iniciar() {
    var mapa = lerMapa();
    if (!mapa) return;
    marcarTamanhos(mapa);
    atualizar(varianteAtual());
  }
 
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", iniciar);
  } else {
    iniciar();
  }
 
  // Exposto para os listeners abaixo
  window.__adoPreVenda = { atualizar: atualizar, iniciar: iniciar };
})();
 
// This event fires whenever an item has been added to the cart.
// This event is exposed when the ajax cart is enabled.
// The product object is passed within the detail object.
document.addEventListener("cart:item-added", function (evt) {
});
 
// This event fires whenever the cart is updated.
// This event is exposed when the ajax cart is enabled.
// The cart object is passed within the detail object.
document.addEventListener("cart:updated", function (evt) {
});
 
// This event fires whenever there is an error when adding an item to the cart.
// This error is typically due to a product not having sufficient stock.
// The error message is passed within the detail object.
document.addEventListener("cart:error", function (evt) {
});
 
// This event fires whenever the quick cart is opened.
// This event is exposed when the ajax cart is enabled.
// The cart object is passed within the detail object.
document.addEventListener("quick-cart:open", function (evt) {
});
 
// This event fires whenever the quick cart is opened.
// This event is exposed when the ajax cart is enabled.
document.addEventListener("quick-cart:close", function () {
});
 
// This event fires whenever a variant product is selected.
// This event is exposed when a 'Variant selectors' block has been added to
// a product template or featured product section
// The selected variant object is passed within the detail object.
document.addEventListener("product:variant-change", function (evt) {
  var variant = evt.detail && evt.detail.variant;
  if (window.__adoPreVenda) {
    window.__adoPreVenda.atualizar(variant ? variant.id : null);
  }
});
 
// This event fires whenever a product quanatiy is updated.
// This event is exposed when a 'Quantity selector' block has been added to
// a product template or featured product section
// The quantity and selected variant object is passed within the detail object.
document.addEventListener("product:quantity-update", function (evt) {
});
 
// This event fires whenever quickview modal is opened.
// This event is exposed when the 'Enable quick view' feature is enabled
// And a quick view modal is opened.
document.addEventListener("quickview:loaded", function () {
  // Reinicializa a pré-venda dentro do quick view recém-carregado
  if (window.__adoPreVenda) {
    window.__adoPreVenda.iniciar();
  }
});